import { render, staticRenderFns } from "./ScheduleCollections.vue?vue&type=template&id=bcf2433e&scoped=true"
import script from "./ScheduleCollections.vue?vue&type=script&lang=js"
export * from "./ScheduleCollections.vue?vue&type=script&lang=js"
import style0 from "./ScheduleCollections.vue?vue&type=style&index=0&id=bcf2433e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf2433e",
  null
  
)

export default component.exports